module.exports = __webpack_public_path__ + "img/before-outdoor-border.31e506c1.png";